//default from angular libraries
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';

//import constants
import { AppFrontRoutes } from './constants/app-front-routes';
import { AppPermissions } from './constants/app-permission';
import { AdminAppPermissions } from './constants/app-permission';

//import common services
import { AuthGuard } from './common/auth-guard';

//import layout component
import { UserLayoutComponent } from './components/layout/user-layout/user-layout.component';

//import component
import { LoginComponent } from './components/user/login/login.component';
import { DashboardComponent } from './components/user/dashboard/dashboard.component';
import { ProfileComponent } from './components/user/profile/profile.component';
import { SettingsComponent } from './components/user/settings/settings.component';
import { SupportTicketListComponent } from './components/user/ticket/support-ticket-list/support-ticket-list.component';
import { SupportTicketCreateComponent } from './components/user/ticket/support-ticket-create/support-ticket-create.component';
import { SupportTicketViewComponent } from './components/user/ticket/support-ticket-view/support-ticket-view.component';
import { DeadlineListComponent } from './components/user/deadline/deadline-list/deadline-list.component';
import { DeadlineViewComponent } from './components/user/deadline/deadline-view/deadline-view.component';
import { ServicingViewComponent } from './components/user/servicing/servicing-list/servicing-view/servicing-view.component';
import { ServicingListComponent } from './components/user/servicing/servicing-list/servicing-list.component';
import { ServicingExtraOrdinaryComponent } from './components/user/servicing/servicing-list/servicing-extraordinary/servicing-extraordinary.component';
import { ServicingOrdinaryComponent } from './components/user/servicing/servicing-list/servicing-ordinary/servicing-ordinary.component';
import { ServicingViewserviceComponent } from './components/user/servicing/servicing-list/servicing-viewservice/servicing-viewservice.component';
import { ServicingMaintenancePlansComponent } from './components/user/servicing/servicing-maintenance_plans/servicing-maintenance_plans.component';
import { ServicingCreateMaintenanceComponent } from './components/user/servicing/servicing-maintenance_plans/servicing-createmaintenance/servicing-createmaintenance.component';


import { NotificationListComponent } from './components/user/human_resources/notification-list/notification-list.component';
import { NotificationCreateComponent } from './components/user/human_resources/notification-create/notification_create.component';
import { NotificationViewComponent } from './components/user/human_resources/notification-list/notification_view/notification-view.component';

import { MedicalExaminationComponent } from './components/user/human_resources/medical_examination/medical_examination.component';
import { MedicalExaminationViewComponent } from './components/user/human_resources/medical_examination/medical-examination-view/medical_examination_view.component'

import { MedicalExaminationCreateComponent } from './components/user/human_resources/medical_examination_create/medical_examination_create.component';

import { EmployeeListComponent } from './components/user/human_resources/employee-list/employee-list.component';
import { SkillsListComponent } from './components/user/human_resources/skills-list/skills-list.component';

import { EmployeeViewComponent } from './components/user/human_resources/employee-list/employee-view/employee-view.component';
import { CreateCourseComponent } from './components/user/human_resources/employee-list/course-create/course_create.component';

import { MeasurementComponent } from './components/user/measurement/measurement.component';
import { CreateMeasurementComponent } from './components/user/measurement/measurement-create/measurement-create.component';
import { MeasurementViewComponent } from './components/user/measurement/measurement-list/measurement-view/measurement-view.component';

import { CalibrationPlansComponent } from './components/user/measurement/measurement-calibration_plans/measurement-calibration_plans.component';

import { ProblemSolvingListComponent } from './components/user/problem_solving/problem_solving_list/problem-solving.component';

import { DocumentMangListComponent } from './components/user/document_management/document_mang/document-mang.component';
import { DocumentMangViewComponent } from './components/user/document_management/document_mang_view/document_mang-view.component';

import { CustomersListComponent } from './components/user/customers/customers_list/customers_list.component';

import { CreateCustomerComponent } from './components/user/customers/customer-create/customer_create.component';

import { CustomersViewComponent } from './components/user/customers/customers_list/customers-view/customers-view.component';
import { ProblemSolvingViewComponent } from './components/user/problem_solving/problem_solving_list/problem-solving-view/problem-solving-view.component';


import { SupplyersListComponent } from './components/user/customers/supplyers/supplyers_list.component';
import { SupplyersViewComponent } from './components/user/customers/supplyers/supplyers-view/supplyers-view.component';



import { ConsultancyListComponent } from './components/user/consultancy/consultancy_list/consultancy_list.component';

import { CreateConsultancyComponent } from './components/user/consultancy/consultancy-create/consultancy_create.component';

import { ConsultancyViewComponent } from './components/user/consultancy/consultancy_list/consultancy-view/consultancy-view.component';
import { ReportingListComponent } from './components/user/consultancy/consultancy_reporting/consultancy-reporting.component';
import { ScheduledCoursesListComponent } from './components/user/academy//scheduled_courses_list/scheduled_courses_list.component';


import { CreateScheduleCourseComponent } from './components/user/academy/scheduled_courses-create/scheduled_courses_create.component';

import { ScheduledCoursesViewComponent } from './components/user/academy/scheduled_courses_list/scheduled-courses-view/scheduled-courses-view.component';

import { AdminSupportTicketListComponent } from './components/user/admin_ticket/admin-support-ticket-list/admin-support-ticket-list.component';

import { AdminSupportTicketCreateComponent } from './components/user/admin_ticket/admin-support-ticket-create/admin-support-ticket-create.component';

import { AdminSupportTicketViewComponent } from './components/user/admin_ticket/admin-support-ticket-view/admin-support-ticket-view.component';

import { MailConfigComponent } from './components/user/mail_config/mail_config.component';

import { CourseCatelogListComponent } from './components/user/academy/course_catelog/course_catelog.component';

import { CourseCatalogViewComponent } from './components/user/academy/course_catelog/course-catalog-view/course-catalog-view.component';

import { QualifiedTeacherListComponent } from './components/user/academy/qualified_teacher/qualified_teacher.component';

import { TeacherCreateComponent } from './components/user/academy/qualified-teacher-create/qualified_teacher_create.component';
import { QualifiedTeacherViewComponent } from './components/user/academy/qualified_teacher/qualified-teacher-view/qualified-teacher-view.component';
import { ProjectListComponent } from './components/user/project/project_list/project.component';
import { ProjectViewComponent } from './components/user/project/project_view/project_view.component';
import { ProjectClassComponent } from './components/user/project/project_class/project_class.component';
import { ProjectReportingListComponent } from './components/user/project/project_reporting/project-reporting.component';
import { AuditListComponent } from './components/user/audit/audit_list/audit_list.component';
import { AuditViewComponent } from './components/user/audit/audit_list/audit-view/audit-view.component';
import { AuditStandardListComponent } from './components/user/audit/audit_standard/audit_standard.component';
import { InstallationListComponent } from './components/super_admin/installation_list/installation-list/installation-list.component';
import { CreateInstallationComponent } from './components/super_admin/installation_list/installation-create/installation_create.component';


import { SuperAdminLoginComponent } from './components/super_admin/super_admin_login/super_admin_login.component';
import { AdminDashboardComponent } from './components/user/admin_dashboard/admin_dashboard.component';
import { SuperAdminDashboardComponent } from './components/super_admin/super_admin_dashboard/super_admin_dashboard.component';
import { SuperAdminUserDetailsComponent } from './components/super_admin/super_admin_user_details/super_admin_user_details.component';
import { PackageListComponent } from './components/super_admin/package/package-list/package-list.component';
//import services
import { ProfileService } from './services/profile.service';
import { ServicingService } from './services/servicing.service';
import { NotificationService } from './services/notification.service';
import { MedicalService } from './services/medical.service';
import { MeasurementService } from './services/measurement.service';
import { SettingsService } from './services/settings.service';
import { DeadlineService } from './services/deadline.service';
import { CustomersService } from './services/customers.service';
import { SuperAdminLangListComponent } from './components/super_admin/super_admin_lang_list/super_admin_lang_list.component';
import { SuperAdminLangDetailsComponent } from './components/super_admin/super_admin_lang_details/super_admin_lang_details.component';
import { SuperAdminMailConfigComponent } from './components/super_admin/super_admin_mail_config/super_admin_mail_config.component';
import { PackageDetailsComponent } from './components/super_admin/package/package-details/package-details.component';
import { TreatmentRegisterComponent } from './components/user/privacy/treatment-register/treatment-register-list/treatment-register.component';
import { CalendarComponent } from  'src/app/components/user/calendar/calendar.component'
import { AppointmentDataProcessorComponent } from './components/user/privacy/appointment-data-processor/appointment-data-processor.component';
import { SkillsCourseViewComponent } from './components/user/human_resources/skills-course-view/skills-course-view.component';
const routes: Routes = [
  //no layout routes
  {
    path: '',
    redirectTo: AppFrontRoutes.LOGIN,
    pathMatch: 'full',
  },
  {
    path: AppFrontRoutes.LOGIN,
    component: LoginComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Login - Kaizencloud',
      permissions: { only: [AppPermissions.NOT_LOGGED_IN], redirectTo: AppFrontRoutes.DASHBOARD }
    }
  },
  {
    path: AppFrontRoutes.SUPERADMIN,
    component: SuperAdminLoginComponent,
    data: {
      title: 'Login - Kaizencloud',
      permissions: { only: [AdminAppPermissions.NOT_LOGGED_IN], redirectTo: AppFrontRoutes.SDASHBOARD }
    }
  },

  // Super Admin Routes
  {
    path: 'super',
    canActivate: [AuthGuard],
    component: SuperAdminDashboardComponent,
    canActivateChild: [NgxPermissionsGuard],
    children: [
      {
        path: AppFrontRoutes.SDASHBOARD,
        component: AdminDashboardComponent,
        data: {
          title: 'Dashboard - Kaizencloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo: AppFrontRoutes.SDASHBOARD }
        },
      },
      {
        path: AppFrontRoutes.INSTALLATION_LIST,
        component: InstallationListComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo:[AppFrontRoutes.SDASHBOARD] },
        },
      },  
      {
        path: AppFrontRoutes.CREATE_INSTALLATION,
        component: CreateInstallationComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo:[AppFrontRoutes.SDASHBOARD] },
        },
      },  
      {
        path: AppFrontRoutes.SUPER_USER_DETAILS+ '/:id',
        component: SuperAdminUserDetailsComponent,
        data: {
          title: 'Kaizencloud User Detail',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo:[AppFrontRoutes.SDASHBOARD] },
        },
      },  
      {
        path: AppFrontRoutes.SUPER_LANG,
        component: SuperAdminLangListComponent,
        data: {
          title: 'Kaizencloud Lang List',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo:[AppFrontRoutes.SDASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.SUPER_LANG+"/:lang",
        component: SuperAdminLangDetailsComponent,
        data: {
          title: 'Kaizencloud Lang List',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo:[AppFrontRoutes.SDASHBOARD] },
        },
      }, 
      {
        path: AppFrontRoutes.SUPER_ADMIN_MAIL_CONFIG,
        component: SuperAdminMailConfigComponent,
        data: {
          title: 'Kaizencloud Mail Config',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo:[AppFrontRoutes.SDASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.ADMIN_TICKET_LIST,
        component: AdminSupportTicketListComponent,
        data: {
          title: 'Admin Ticket List - Kaizencloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo: AppFrontRoutes.LOGIN }
        },
      }, 
      {
        path: AppFrontRoutes.ADMIN_TICKET_VIEW + '/:id',
        component: AdminSupportTicketViewComponent,
        data: {
          title: 'Admin Ticket View - Kaizencloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo: AppFrontRoutes.LOGIN }
        },
      }, 
      {
        path: AppFrontRoutes.ADMIN_PACKAGE_LIST,
        component: PackageListComponent,
        data: {
          title: 'Admin Package List - Kaizencloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo: AppFrontRoutes.LOGIN }
        },
      },    
      {
        path: AppFrontRoutes.ADMIN_PACKAGE_LIST+"/:id",
        component: PackageDetailsComponent,
        data: {
          title: 'Admin Package List - Kaizencloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo: AppFrontRoutes.LOGIN }
        },
      },
    ] 
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: UserLayoutComponent,
    canActivateChild: [NgxPermissionsGuard],
    children: [
      {
        path: AppFrontRoutes.DASHBOARD,
        component: DashboardComponent,
        data: {
          title: 'Dashboard - Kaizencloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo: AppFrontRoutes.LOGIN }
        },
      },
      {
        path: AppFrontRoutes.PROFILE,
        component: ProfileComponent,
        resolve: { data: ProfileService },
        data: {
          title: 'Profile - Kaizencloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo: AppFrontRoutes.LOGIN }
        },
      },
      {
        path: AppFrontRoutes.SETTINGS,
        component: SettingsComponent,
        resolve: { data: SettingsService },
        data: {
          title: 'Settings - Kaizencloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo: AppFrontRoutes.LOGIN }
        },
      },
      {
        path: AppFrontRoutes.TICKET_CREATE,
        component: SupportTicketCreateComponent,
        data: {
          title: 'Support Ticket Create - Kaizencloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo: AppFrontRoutes.LOGIN }
        },
      },
      {
        path: AppFrontRoutes.TICKET_VIEW + '/:id',
        component: SupportTicketViewComponent,
        data: {
          title: 'Support Ticket View - Kaizencloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo: AppFrontRoutes.LOGIN }
        },
      },

      //Deadline routes
      {
        path: AppFrontRoutes.Deadline_List,
        component: DeadlineListComponent,
        resolve: { data: DeadlineService },
        data: {
          title: 'Deadlines - Kaizencloud',
          permissions: { only: [AppPermissions.DEADLINE], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },
      {
        path: AppFrontRoutes.DEADLINE_VIEW + '/:id',
        component: DeadlineViewComponent,
        data: {
          title: 'Deadlines - Kaizencloud',
          permissions: { only: [AppPermissions.DEADLINE], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },

      //Servicing routes
      {
        path: AppFrontRoutes.Servicing_List,
        component: ServicingListComponent,
        resolve: { sdata: ServicingService },
        data: {
          title: 'Servicing - Kaizencloud',
          permissions: { only: [AppPermissions.SERVICING], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },

      //Servicing view
      {
        path: AppFrontRoutes.SERVICING_VIEW + '/:id',
        component: ServicingViewComponent,
        resolve: { sdata: ServicingService },
        data: {
          title: 'Servicing View - Kaizencloud',
          permissions: { only: [AppPermissions.SERVICING], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },

      {
        path: AppFrontRoutes.MAINTENANCE_PLANS,
        component: ServicingMaintenancePlansComponent,
        resolve: { sdata: ServicingService },
        data: {
          title: 'Servicing - Kaizencloud',
          permissions: { only: [AppPermissions.SERVICING], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },

      //Human Resources Routes
      {
        path: AppFrontRoutes.EMPLOYEE_LIST,
        component: EmployeeListComponent,
        data: {
          title: 'Kaizen cloud',
          permissions: { only: [AppPermissions.HUMAN_RESOURCE], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.EMPLOYEE_VIEW + '/:id',
        component: EmployeeViewComponent,
        data: {
          title: 'Kaizen cloud',
          permissions: { only: [AppPermissions.HUMAN_RESOURCE], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.CREATE_COURSE,
        component: CreateCourseComponent,
        data: {
          title: 'Kaizen cloud',
          permissions: { only: [AppPermissions.SERVICING], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.UPDATE + '/:id',
        component: CreateCourseComponent,
        data: {
          title: 'Kaizen cloud',
          permissions: { only: [AppPermissions.SERVICING], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },


      {
        path: AppFrontRoutes.Notification_List,
        component: NotificationListComponent,
        data: {
          title: 'Notification - Kaizencloud',
          permissions: { only: [AppPermissions.SERVICING], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },

      {
        path: AppFrontRoutes.ADD_NOTIFICATION,
        component: NotificationCreateComponent,
        resolve: { data: NotificationService },
        data: {
          title: 'Notification - Kaizencloud',
          permissions: { only: [AppPermissions.SERVICING], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.NOTIFICATION_VIEW + '/:id',
        component: NotificationViewComponent,
        resolve: { sdata: NotificationService },
        data: {
          title: 'Notification View - Kaizencloud',
          permissions: { only: [AppPermissions.SERVICING], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },
      {
        path: AppFrontRoutes.SKILLS_LIST,
        component: SkillsListComponent,
        data: {
          title: 'Kaizen cloud',
          permissions: { only: [AppPermissions.SERVICING], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.SKILLS_COURSE_LIST + '/:id',
        component: SkillsCourseViewComponent,
        data: {
          title: 'Kaizen cloud',
          permissions: { only: [AppPermissions.SERVICING], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },            
      {
        path: AppFrontRoutes.MEDICAL_EXAMINATION,
        component: MedicalExaminationComponent,
        data: {
          title: 'Medical Examination - Kaizencloud',
          permissions: { only: [AppPermissions.SERVICING], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.NEW_EXAMINATION,
        component: MedicalExaminationCreateComponent,
        resolve: { data: MedicalService },
        data: {
          title: 'Medical Examination - Kaizencloud',
          permissions: { only: [AppPermissions.SERVICING], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.EXAMINATION_VIEW+ '/:id',
        component: MedicalExaminationViewComponent,
        resolve: { data: MedicalService },
        data: {
          title: 'Medical Examination - Kaizencloud',
          permissions: { only: [AppPermissions.SERVICING], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },      
      {
        path: AppFrontRoutes.MEASUREMENT,
        component: MeasurementComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.MEASUREMENT_TOOL], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },
      {
        path: AppFrontRoutes.CREATE,
        component: CreateMeasurementComponent,
        data: {
          title: 'Kaizen cloud',
          permissions: { only: [AppPermissions.MEASUREMENT_TOOL], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.EDIT + '/:id',
        component: CreateMeasurementComponent,
        // resolve: { data: MeasurementService },
        data: {
          title: 'Kaizen cloud',
          permissions: { only: [AppPermissions.MEASUREMENT_TOOL], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.SINGLE_VIEW + '/:id',
        component: MeasurementViewComponent,
        data: {
          title: 'Single View - Kaizencloud',
          permissions: { only: [AppPermissions.MEASUREMENT_TOOL], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },
      {
        path: AppFrontRoutes.CALIBRATION_PLANS,
        component: CalibrationPlansComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.MEASUREMENT_TOOL], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },
      //Problem solving routes
      {
        path: AppFrontRoutes.PROBLEM_SOLVING,
        component: ProblemSolvingListComponent,
        data: {
          title: 'Problem Solving View - Kaizencloud',
          permissions: { only: [AppPermissions.PROBLEM_SOLVING], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.VIEW_PROBLEM_DETAILS + '/:id',
        component: ProblemSolvingViewComponent,
        data: {
          title: 'Problem Solving View - Kaizencloud',
          permissions: { only: [AppPermissions.PROBLEM_SOLVING], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },
      //Document management routes
      {
        path: AppFrontRoutes.DOCUMENT_MANAGEMENT,
        component: DocumentMangListComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.DOCUMENT_MANAGEMENT], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.DOCUMENTMANG_VIEW + '/:id',
        component: DocumentMangViewComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.DOCUMENT_MANAGEMENT], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },
       //Customers routes
       {
        path: AppFrontRoutes.CUSTOMERS,
        component: CustomersListComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.DOCUMENT_MANAGEMENT], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.CREATE_CUSTOMER,
        component: CreateCustomerComponent,
        data: {
          title: 'Kaizen cloud',
          permissions: { only: [AppPermissions.SERVICING], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.EDIT_CUSTOMER + '/:id',
        component: CreateCustomerComponent,
        data: {
          title: 'Kaizen cloud',
          permissions: { only: [AppPermissions.SERVICING], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.CUSTOMERS_VIEW + '/:id',
        component: CustomersViewComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.DOCUMENT_MANAGEMENT], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },
      {
       path: AppFrontRoutes.CONSULTANCY,
       component: ConsultancyListComponent,
       data: {
         title: 'Kaizencloud',
         permissions: { only: [AppPermissions.CONSULTANCY], redirectTo: [AppFrontRoutes.DASHBOARD] },
       },
      },
      {
        path: AppFrontRoutes.CREATE_CONSULTANCY,
        component: CreateConsultancyComponent,
        data: {
          title: 'Kaizen cloud',
          permissions: { only: [AppPermissions.CONSULTANCY], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.EDIT_CONSULTANCY + '/:id',
        component: CreateConsultancyComponent,
        // resolve: { data: MeasurementService },
        data: {
          title: 'Kaizen cloud',
          permissions: { only: [AppPermissions.CONSULTANCY], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.CONSULTANCY_VIEW + '/:id',
        component: ConsultancyViewComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.CONSULTANCY], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },
      {
        path: AppFrontRoutes.REPORTING,
        component: ReportingListComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.CONSULTANCY], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.SCHEDULEDCOURSES,
        component: ScheduledCoursesListComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.ACADEMY], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.CREATE_SCHEDULE_COURSE,
        component: CreateScheduleCourseComponent,
        data: {
          title: 'Kaizen cloud',
          permissions: { only: [AppPermissions.ACADEMY], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.SCHEDULED_COURSE_VIEW + '/:id',
        component: ScheduledCoursesViewComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.DOCUMENT_MANAGEMENT], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },
      {
        path: AppFrontRoutes.TICKET_LIST,
        component: AdminSupportTicketListComponent,
        data: {
          title: 'Admin Ticket List - Kaizencloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo: AppFrontRoutes.LOGIN }
        },
      },
      {
        path: AppFrontRoutes.ADMIN_TICKET_VIEW + '/:id',
        component: AdminSupportTicketViewComponent,
        data: {
          title: 'Admin Ticket View - Kaizencloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo: AppFrontRoutes.LOGIN }
        },
      },
      {
        path: AppFrontRoutes.ADMIN_MAIL_CONFIG,
        component: MailConfigComponent,
        data: {
          title: 'Kaizen cloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.COURSE_CATELOG,
        component: CourseCatelogListComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.ACADEMY], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.COURSE_CATALOG_VIEW + '/:id',
        component: CourseCatalogViewComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.ACADEMY], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },
      {
        path: AppFrontRoutes.QUALIFIED_TEACHER,
        component: QualifiedTeacherListComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.ACADEMY], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.QUALIFIED_TEACHER_CREATE,
        component: TeacherCreateComponent,
        data: {
          title: 'Kaizen cloud',
          permissions: { only: [AppPermissions.ACADEMY], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.QUALIFIED_TEACHER_EDIT + '/:id',
        component: TeacherCreateComponent,
        data: {
          title: 'Kaizen cloud',
          permissions: { only: [AppPermissions.ACADEMY], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.QUALIFIED_TEACHER_VIEW + '/:id',
        component: QualifiedTeacherViewComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.ACADEMY], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },
      {
        path: AppFrontRoutes.PROJECT,
        component: ProjectListComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.PROJECT], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.PROJECT_VIEW + '/:id',
        component: ProjectViewComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.PROJECT], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },
      {
        path: AppFrontRoutes.PROJECT_CLASS,
        component: ProjectClassComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.PROJECT], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.PROJECT_REPORTING,
        component: ProjectReportingListComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.CONSULTANCY], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.AUDIT_LIST,
        component: AuditListComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.AUDIT], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.AUDIT_VIEW + '/:id',
        component: AuditViewComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.AUDIT], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },
      {
        path: AppFrontRoutes.STANDARD,
        component: AuditStandardListComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.AUDIT], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.INSTALLATION_LIST,
        component: InstallationListComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo:[AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.CREATE_INSTALLATION,
        component: CreateInstallationComponent,
        data: {
          title: 'Kaizen cloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.SDASHBOARD,
        component: AdminDashboardComponent,
        data: {
          title: 'Dashboard - Kaizencloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },
      {
        path: AppFrontRoutes.SUPPLYERS,
        component: SupplyersListComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.DOCUMENT_MANAGEMENT], redirectTo: [AppFrontRoutes.DASHBOARD] },
        },
      },
      {
        path: AppFrontRoutes.SUPPLYERS_VIEW + '/:id',
        component: SupplyersViewComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.DOCUMENT_MANAGEMENT], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },
      {
        path: AppFrontRoutes.PRIVACY_TREATMENT_REGISTER,
        component: TreatmentRegisterComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.DOCUMENT_MANAGEMENT], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },
      {
        path: AppFrontRoutes.PRIVACY_APPOINTMENT_REGISTER,
        component: AppointmentDataProcessorComponent,
        data: {
          title: 'Kaizencloud',
          permissions: { only: [AppPermissions.DOCUMENT_MANAGEMENT], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },
      
      {
        path: AppFrontRoutes.CALENDAR,
        component: CalendarComponent,
        data: {
          title: 'Calendar - Kaizencloud',
          permissions: { only: [AppPermissions.LOGGED_IN], redirectTo: AppFrontRoutes.DASHBOARD }
        },
      },            
    ]
  },
  {
    path: '**',
    component: LoginComponent,
    data: {
      title: 'Kaizencloud',
    }
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
